function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 4 4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.436.992v.685l.239.151h.026l1.03-.694a.15.15 0 0 0-.12-.141Z",
    style: {
      fill: "#0072c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.436 1.932.218.15a.07.07 0 0 0 .068 0c-.037.023 1.009-.672 1.009-.672v1.258a.176.176 0 0 1-.186.194H2.436zm-1.131-.316a.2.2 0 0 0-.177.105.5.5 0 0 0-.066.277.5.5 0 0 0 .065.277.2.2 0 0 0 .346.003.5.5 0 0 0 .064-.275.55.55 0 0 0-.063-.285.19.19 0 0 0-.171-.101",
    style: {
      fill: "#0072c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.269.644v2.678l2.038.428V.25Zm1.363 1.792a.4.4 0 0 1-.338.17.4.4 0 0 1-.33-.165.68.68 0 0 1-.126-.428.73.73 0 0 1 .13-.452.41.41 0 0 1 .343-.173.39.39 0 0 1 .326.165.7.7 0 0 1 .125.435.72.72 0 0 1-.129.448",
    style: {
      fill: "#0072c6"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookLogo);
export default __webpack_public_path__ + "static/media/outlookLogo.eee76e25464f5ce6c0799b2fda7a7d4f.svg";
export { ForwardRef as ReactComponent };